import React from 'react'
import { CommonStyle } from '../styles/common-styles';
import teamImage from '../public/images/team.png';
import Head from 'next/head';
import { DownloadAppFooter } from '../components/download-app-footer';
import Image from 'next/image';


function Aboutus() {

    return (
        <div className="container-fluid p-0">
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care - About Us: Passionate About Your Auto Experience" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/aboutus.html" hrefLang="en" />
            </Head>
            <CommonStyle>
                <div className="bg-light-white container-fluid pt-3 px-0" >
                    <div className="container" style={{ minHeight: 460, height: 460 }}>
                        <div className="d-md-flex mt-5 pb-5">
                            <div className="caption col-md-7 col-lg-6 d-flex flex-column ">
                                <div className="col-md-10 mt-lg-5 ">
                                    <p className="text-danger fw-bold cursor-pointer uppercase" >About Us</p>
                                    <h1 className="heavy-bold dark-text">{`Our Roots & People`}</h1>
                                    <h3 className="grey-text mt-4">
                                        Our roots date back to 1927, located in the heart of the San Antonio community. We focus on getting drivers back on the road quickly with on-site and mobile services, ASE Certified Technicians, and 120,000 parts on location, creating a full-service SPEED + RELIABILITY experience.
                                    </h3>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6 my-4 my-lg-0 text-center position-relative">
                                <div className='position-absolute'>
                                    <Image src={teamImage.src} alt='top-banner' className="img-fluid rounded"  width={710} height={550} loading="lazy" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='bg-white py-5'>
                        <div className='container mt-5 py-5 d-flex justify-content-center'>
                            <div className='pt-5 d-md-flex flex-wrap justify-content-center'>
                                <div className='col-md-4 mb-5 mb-md-0 d-flex justify-content-center flex-column align-items-center text-center'>
                                    <div className="mb-3 team-border-cover">
                                        <Image
                                            src="/images/team/paul.png"
                                            alt="profile"
                                            className="border img-fluid"
                                            width={200}
                                            height={200}
                                            style={{ borderRadius: '50%', objectFit: 'cover', objectPosition: '0 0px' }}
                                            loading="lazy"
                                        />
                                    </div>
                                    <p className='dark-text bold mb-0'>Paul Black</p>
                                    <p className='grey-text'>{`CEO`}</p>
                                </div>
                                <div className='col-md-4 mb-5 mb-md-0 d-flex justify-content-center flex-column align-items-center text-center'>
                                    <div className="mb-3 team-border-cover">
                                        <Image
                                        src="/images/team/robert.png"
                                        alt="profile"
                                        className="border img-fluid"
                                        width={200}
                                        height={200}
                                        style={{ borderRadius: '50%', objectFit: 'cover', objectPosition: '0 0px' }}
                                        loading="lazy"
                                        />
                                    </div>
                                    <p className='dark-text bold mb-0'>Robert Black</p>
                                    <p className='grey-text'>{`COO`}</p>
                                </div>
                                <div className='col-md-4 mb-5 mb-md-0 d-flex justify-content-center flex-column align-items-center text-center'>

                                    <div className="mb-3 team-border-cover">
                                    <Image
                                        src="/images/team/phillip.png"
                                        alt="profile"
                                        className="border img-fluid"
                                        width={200}
                                        height={200}
                                        style={{ borderRadius: '50%', objectFit: 'cover', objectPosition: '0 0px' }}
                                        loading="lazy"
                                    />
                                    </div>
                                    <p className='dark-text bold mb-0'>Phillip Rosales</p>
                                    <p className='grey-text'>{`General Manager`}</p>
                                </div>
                                <div className='col-md-4 mb-5 mb-md-0 d-flex justify-content-center flex-column align-items-center text-center'>

                                    <div className="mb-3 team-border-cover">
                                    <Image
                                        src="/images/team/piyush.png"
                                        alt="profile"
                                        className="border img-fluid"
                                        width={200}
                                        height={200}
                                        style={{ borderRadius: '50%', objectFit: 'cover', objectPosition: '0 0px' }}
                                        loading="lazy"
                                    />
                                    </div>
                                    <p className='dark-text bold mb-0'>Piyush Prakash</p>
                                    <p className='grey-text'>{`Co-Founder & CTO`}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DownloadAppFooter/>
                </div>
            </CommonStyle>
        </div>
    )
}

export default Aboutus